import { Box, Typography } from "@mui/material";
import IconCurrencyFelix from "../../util/iconCurrencyFelix";
import { useEffect, useState } from "react";
import Credito from "../../../models/credito";
import { onSnapshot } from "firebase/firestore";
import { useUsuario } from "../../../providers/usuarioProvider";
import CreditoDb from "../../../db/creditoDb";
import InteiroText from "../../util/ui/inputs/inteiroText";
import { radius } from "../../../theme";

export default function SaldoCreditos() {
  const { usuario } = useUsuario();
  const [credito, setCredito] = useState<Credito>();
  useEffect(() => {
    if (!!usuario)
      return onSnapshot(
        new CreditoDb().doc({ creditoId: usuario.business || usuario.id }),
        (doc) => setCredito(doc.data())
      );
  }, [usuario?.business, usuario?.id]);
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      mx={1}
      py={1}
      borderRadius={`${radius.lg}px`}
      bgcolor="tertiary.main"
    >
      <Typography
        variant="dataMono"
        color="tertiary.contrastText"
        sx={{ fontWeight: 600 }}
      >
        <InteiroText value={credito?.saldo || 0} />
      </Typography>

      <Box sx={{ color: "tertiary.contrastText" }}>
        <IconCurrencyFelix />
      </Box>
    </Box>
  );
}
